import React from 'react';
import {
  Form, Row, Col, Input, Button, Checkbox
} from 'antd';
import img from './../../assets/img/Illustration.png';
class FD extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler({ ...values}, (val) => {
          if (!val) {
          }
        });
      }
    });
  }
  constructor(props) {
    
    super(props);
    this.state = {
    }
    const { setFieldsValue } = this.props.form;         
    setTimeout(() => {
      setFieldsValue({
        npn: this.props.userNpn
      });
    }, 100);
  }


  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p className='mi_title'>{this.props.title}</p>
          </Col>
          <Col span={6}>
            <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{ color: 'red' }} onClick={this.props.closeDrawerHandler} ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>

            <Col md={24} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Provide Your NPN </legend>
                  {getFieldDecorator('npn', {
                    rules: [{ required: true, message: 'Please enter NPN details.' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[0-9]{9,9}$/,
                      message: "It allows only Numerics,Value length should be 9 "
                    }],
                  })(<Input autoComplete={"nope"}   maxLength={10} className="mi_input" type="text" placeholder='Provide Your NPN' />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={24} sm={24}>
              <p style={{margin:'0px 12px'}}>
              &nbsp;&nbsp;&nbsp;&nbsp;We do hereby confirm that the sole purpose of using NPN shall be to get the License Information from National Insurance Producer Registry  for showing the relevant information . We shall not share or use your NPN in any other form or for any other matter . By Accepting this you are providing consent to use your NPN for the sole purpose of National Insurance Producer Registry   verification 
              </p>
            </Col>
            <Col md={24} sm={24}>
              <Form.Item>
              {getFieldDecorator('tnc', {
                    rules: [{ required: true, message: 'Please agree to Terms and Conditions.' }],
                  })(
                <Checkbox style={{margin:'5px 12px'}}>I agree to all the Terms and Conditions hereby.</Checkbox>)}

              </Form.Item>
            </Col>
            <Col md={24} sm={24}>
              <Form.Item>
              {getFieldDecorator('isDontShowAgainTermsandConditions', {
                    rules: [{ required: false, message: 'Please agree to Terms and Conditions.' }],
                  })(
                <Checkbox style={{margin:'0px 12px'}}>Don't show again.</Checkbox>)}

              </Form.Item>
            </Col>
          </Row>
          <Row span={24} style={{ marginTop: '20px' }}>
            <Col span={7} ></Col>
            <Col span={5} >
              <Button className="mi_button_right" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                Close
              </Button>
            </Col>
            <Col span={5} >
              <Button htmlType="submit" type="primary" >
                Accept
              </Button>
            </Col>
            <Col span={7} >
              <img alt="example" style={{ width: 105, marginBottom: '-28px', float: 'right' }} src={img} />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const ProvideNPNDrawer = Form.create()(FD);
export default ProvideNPNDrawer;